(function() {
  'use strict';
  
  angular
    .module('app.myPolls')
    .controller('SettingsController', SettingsController);
      
  SettingsController.$inject = [
    '$log', 
    '$scope',
    'shell',  
    'settings',
    'viewSyncService'
  ];
    
  function SettingsController(
      $log, 
      $scope, 
      shell, 
      settings,
      viewSyncService
  ) {
    
    $log = $log.getInstance('SettingsController');
    
    /* jshint validthis: true */
    var vm = this;
    
    vm.defaultSettings = defaultSettings;
    vm.hideResultsByDefault = undefined;
    vm.isViewSynchronized = undefined;
    vm.shell = shell;
    vm.onHideResultsByDefaultChanged = onHideResultsByDefaultChanged;
    vm.onIsViewSynchronizedChanged = onIsViewSynchronizedChanged;

    activate();
    
    function activate() {
      shell.setTitle('Settings');

      vm.hideResultsByDefault = settings.get('shell.result.hideByDefault', false);
      vm.isViewSynchronized = settings.get('shell.myPolls.isViewSynchronized', true);
    }

    function defaultSettings() {
      vm.hideResultsByDefault = false;
      vm.isViewSynchronized = true;
      onHideResultsByDefaultChanged();
      onIsViewSynchronizedChanged();
    }

    function onHideResultsByDefaultChanged() {
      settings.set('shell.result.hideByDefault', vm.hideResultsByDefault);
      return saveDebounced();
    }

    function onIsViewSynchronizedChanged() {
      vm.isViewSynchronized
        ? viewSyncService.enable()
        : viewSyncService.disable();
      settings.set('shell.myPolls.isViewSynchronized', vm.isViewSynchronized);
      return saveDebounced();
    }

    var saveDebounced = _.debounce(settings.save, 500);

  }
  
})();